// removed by extract-text-webpack-plugin
module.exports = {"button":"i9V8x"};


//////////////////
// WEBPACK FOOTER
// ./app/components/floating-create-button/floating-create-button.scss
// module id = 1528
// module chunks = 0